/* Real PDF samples, progressive image links, and native Shopify variant URLs. */
(() => {
  if (window.momoProductGalleryLoaded) return;
  window.momoProductGalleryLoaded = true;

  function setup(root) {
    if (root.dataset.mcpReady) return;
    root.dataset.mcpReady = 'true';
    const slides = [...root.querySelectorAll('[data-mcp-slide]')];
    const buttons = [...root.querySelectorAll('.mcp-thumbnail')];
    const status = root.querySelector('[data-mcp-gallery-status]');
    const stage = root.querySelector('.mcp-stage');
    const pagination = root.querySelector('[data-mcp-pagination]');
    // Keep portrait and landscape films whole; controls follow the actual picture.
    function fitFilms() {
      slides.filter(slide => !slide.hidden).forEach(slide => {
        const video = slide.querySelector('video');
        const player = video?.closest('.mc-player');
        if (!player || !slide.clientWidth || !slide.clientHeight) return;
        const ratio = video.videoWidth && video.videoHeight ? video.videoWidth / video.videoHeight : 9 / 16;
        const width = Math.min(slide.clientWidth, slide.clientHeight * ratio);
        player.style.width = `${width}px`;
        player.style.height = `${width / ratio}px`;
      });
    }
    slides.forEach(slide => slide.querySelector('video')?.addEventListener('loadedmetadata', fitFilms));
    const filmResize = 'ResizeObserver' in window ? new ResizeObserver(fitFilms) : null;
    if (stage) filmResize?.observe(stage);
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => filmResize?.disconnect());
    let selectedIndex = 0;
    const dots = buttons.map((button, index) => {
      if (!pagination) return null;
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mcp-gallery-dot';
      dot.setAttribute('aria-controls', button.getAttribute('aria-controls'));
      dot.setAttribute('aria-label', `${index + 1} of ${buttons.length}: ${button.getAttribute('aria-label').replace(/^show /, '')}`);
      dot.addEventListener('click', () => selectSlide(button));
      pagination.append(dot);
      return dot;
    }).filter(Boolean);

    function selectSlide(button, announce = true) {
      selectedIndex = buttons.indexOf(button);
      const id = button.getAttribute('aria-controls');
      slides.forEach(slide => {
        const selected = slide.id === id;
        if (!selected) slide.querySelectorAll('video').forEach(video => video.pause());
        slide.hidden = !selected;
      });
      fitFilms();
      buttons.forEach(item => {
        item.setAttribute('aria-pressed', String(item === button));
        item.tabIndex = item === button ? 0 : -1;
      });
      dots.forEach((dot, index) => {
        dot.setAttribute('aria-pressed', String(index === selectedIndex));
        dot.tabIndex = index === selectedIndex ? 0 : -1;
      });
      if (announce && status) status.textContent = `${selectedIndex + 1} of ${buttons.length}: ${button.getAttribute('aria-label').replace(/^show /, '')}`;
    }

    function addArrowNavigation(button, index, controls) {
      button.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        selectSlide(buttons[next]);
        controls[next].focus({ preventScroll: true });
        controls[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => selectSlide(button));
      addArrowNavigation(button, index, buttons);
    });
    dots.forEach((dot, index) => addArrowNavigation(dot, index, dots));
    if (buttons[0]) selectSlide(buttons[0], false);

    // Swipe changes the selected media without hijacking vertical page scrolling.
    if (stage && buttons.length > 1) {
      let pointerStart;
      let suppressClick = false;
      stage.style.touchAction = 'pan-y pinch-zoom';
      stage.addEventListener('pointerdown', event => {
        if (!event.isPrimary) return;
        pointerStart = null;
        // Native video scrubbing must never become a gallery swipe.
        if (event.pointerType === 'mouse' || event.target.closest('button') || event.target.closest('video')?.controls) return;
        pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
      });
      stage.addEventListener('pointercancel', () => { pointerStart = null; });
      stage.addEventListener('pointerup', event => {
        if (!pointerStart || pointerStart.id !== event.pointerId) return;
        const dx = event.clientX - pointerStart.x;
        const dy = event.clientY - pointerStart.y;
        pointerStart = null;
        if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        selectSlide(buttons[(selectedIndex + (dx < 0 ? 1 : -1) + buttons.length) % buttons.length]);
        suppressClick = true;
        setTimeout(() => { suppressClick = false; }, 350);
      });
      stage.addEventListener('click', event => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressClick = false;
      }, true);
    }

    root.querySelector('[data-mcp-variant]')?.addEventListener('change', event => {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', event.target.value);
      window.location.assign(url.href);
    });

    const dialog = root.querySelector('[data-mcp-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const samples = [...root.querySelectorAll('[data-mcp-sample]')].map(figure => ({
      src: figure.querySelector('a').href,
      caption: figure.dataset.caption,
      alt: figure.querySelector('img').alt,
      width: Number(figure.querySelector('img').getAttribute('width'))
    }));
    const image = dialog.querySelector('[data-mcp-preview-image]');
    const caption = dialog.querySelector('[data-mcp-preview-caption]');
    const original = dialog.querySelector('[data-mcp-preview-original]');
    const viewport = dialog.querySelector('[data-mcp-preview-viewport]');
    const zoom = dialog.querySelector('[data-mcp-preview-zoom]');
    const previous = dialog.querySelector('[data-mcp-preview-prev]');
    const next = dialog.querySelector('[data-mcp-preview-next]');
    let active = 0;
    let trigger;
    let previousOverflow;

    function setZoom(enlarged) {
      dialog.classList.toggle('is-zoomed', enlarged);
      zoom.setAttribute('aria-pressed', String(enlarged));
      zoom.textContent = enlarged ? 'fit page' : 'zoom in';
      viewport.scrollTo(0, 0);
    }

    function showSample(index) {
      active = (index + samples.length) % samples.length;
      const sample = samples[active];
      image.src = sample.src;
      image.alt = sample.alt;
      original.href = sample.src;
      caption.textContent = `${sample.caption} · sample\u00a0${active + 1}\u00a0of\u00a0${samples.length}`;
      dialog.style.setProperty('--mcp-preview-width', `${sample.width || 1132}px`);
      previous.disabled = next.disabled = samples.length < 2;
      setZoom(false);
    }

    root.querySelectorAll('[data-mcp-preview]').forEach(link => {
      link.addEventListener('click', event => {
        // Preserve new-tab, download, and no-JavaScript image access.
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const index = Number(link.dataset.mcpPreview);
        if (!samples[index]) return;
        event.preventDefault();
        trigger = link;
        showSample(index);
        root.querySelectorAll('video').forEach(video => video.pause());
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-mcp-preview-close]').addEventListener('click', () => dialog.close());
    previous.addEventListener('click', () => showSample(active - 1));
    next.addEventListener('click', () => showSample(active + 1));
    zoom.addEventListener('click', () => setZoom(!dialog.classList.contains('is-zoomed')));
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Tab') {
        const focusable = [...dialog.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]')]
          .filter(element => element.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
        return;
      }
      // Arrow keys remain available for scrolling an enlarged page.
      const fit = !dialog.classList.contains('is-zoomed');
      if (event.key === 'PageDown' || (fit && event.key === 'ArrowRight')) {
        event.preventDefault();
        showSample(active + 1);
      } else if (event.key === 'PageUp' || (fit && event.key === 'ArrowLeft')) {
        event.preventDefault();
        showSample(active - 1);
      }
    });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow || '';
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    });
    const section = root.closest('.shopify-section') || root;
    section.addEventListener('shopify:section:unload', () => {
      if (dialog.open) dialog.close();
    });
  }

  function initialize(scope = document) {
    if (scope.matches?.('[data-mcp]')) setup(scope);
    scope.querySelectorAll('[data-mcp]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
